// The upstream message a project action fails with when the plan's project
// slots are used up. Compared against parseNestError output, so it has to stay
// byte-identical to what the Nest API returns.
export const PROJECTS_LIMIT_REACHED = 'Projects limit reached'
